import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: React.ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-transition page-transition-enter-active">
      {children}
    </div>
  );
};
